
// Artikel mit Byline Dr. Mickel – nach Veröffentlichung hier eintragen.
const ARTICLES = [
  // { title: 'Warum Videofeedback Lernen beschleunigt', path: '/blog/...' }
]

export default {
  name: 'AuthorChristophMickel',
  nuxtI18n: {
    paths: {
      de: '/team/christoph-mickel',
      en: '/team/christoph-mickel'
    }
  },
  data () {
    return {
      focus: ['variability', 'motor', 'feedback', 'video'],
      articles: ARTICLES
    }
  },
  head () {
    const title = 'Dr. Christoph Mickel'
    const description = this.$t('author.meta.description')
    return {
      title: title + ' | ATHLYZER',
      meta: [
        { hid: 'description', name: 'description', content: description },
        { hid: 'og:type', property: 'og:type', content: 'profile' },
        { hid: 'og:title', property: 'og:title', content: title + ' | ATHLYZER' },
        { hid: 'og:description', property: 'og:description', content: description }
      ],
      script: [
        {
          hid: 'ld-person',
          type: 'application/ld+json',
          json: {
            '@context': 'https://schema.org',
            '@type': 'Person',
            name: 'Christoph Mickel',
            honorificPrefix: 'Dr.',
            jobTitle: 'Geschäftsführer',
            image: 'https://www.athlyzer.com/team/christoph-mickel.png',
            url: 'https://www.athlyzer.com/team/christoph-mickel/',
            worksFor: { '@type': 'Organization', name: 'ATHLYZER GmbH', url: 'https://www.athlyzer.com' },
            alumniOf: { '@type': 'CollegeOrUniversity', name: 'Goethe-Universität Frankfurt am Main' },
            knowsAbout: ['Sportwissenschaft', 'Bewegungswissenschaft', 'Motorisches Lernen', 'Videoanalyse im Sport'],
            sameAs: [
              'https://sport.uni-frankfurt.de/52601358/Dr__Christoph_Mickel',
              'https://scholar.google.com/citations?user=mnp0VCoAAAAJ'
            ]
          }
        }
      ]
    }
  }
}
